import { Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Add, Minus } from "iconsax-react";
import { memo, useCallback } from "react";

import { SefanoIconButton } from "@/components/Atoms";
import type { QuantityStepperProps } from "./QuantityStepper.types";
import * as styles from "./QuantityStepper.styles";

export type { QuantityStepperProps } from "./QuantityStepper.types";

export const QuantityStepper = memo(function QuantityStepper({
  value,
  min = 0,
  max = 9999,
  onChange,
}: QuantityStepperProps) {
  const theme = useTheme();

  const handleDecrease = useCallback(() => {
    if (value > min) {
      onChange?.(value - 1);
    }
  }, [min, onChange, value]);

  const handleIncrease = useCallback(() => {
    if (value < max) {
      onChange?.(value + 1);
    }
  }, [max, onChange, value]);

  return (
    <Stack direction="row" alignItems="center" sx={styles.root}>
      <SefanoIconButton
        variant="ghost"
        onClick={handleDecrease}
        iconColor={theme.palette.primary.main}
        aria-label="decrease"
      >
        <Minus size={18} variant="Linear" />
      </SefanoIconButton>
      <Typography sx={styles.value}>{value}</Typography>
      <SefanoIconButton
        variant="ghost"
        onClick={handleIncrease}
        iconColor={theme.palette.primary.main}
        aria-label="increase"
      >
        <Add size={18} variant="Linear" />
      </SefanoIconButton>
    </Stack>
  );
});
